<template>
  <h2 class="form-title">房地产价值报告</h2>
  <div class="table-container">
    <el-form>
      <el-form-item label="房屋类型：" :required="true">
        <el-select v-model="housetype" name="housetype">
          <el-option
            v-for="option in housetypes"
            :key="option"
            :label="option"
            :value="option"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标准城市名：" :required="true">
        <el-input v-model="city" placeholder="格式示例：北京市"></el-input>
      </el-form-item>
      <el-form-item label="详细地址：" :required="true">
        <el-input
          v-model="address"
          placeholder="格式示例：北京市昌平区文化东路233号7号楼1单元802室"
        ></el-input>
      </el-form-item>
      <el-form-item label="房屋面积：" :required="true">
        <el-input
          v-model="area"
          placeholder="格式示例：123.63"
          type="number"
          min="0"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请人手机号：" :required="true">
        <el-input
          v-model="phone"
          placeholder="格式示例：13999999999"
          type="tel"
        ></el-input>
      </el-form-item>
      <el-form-item label="小区：" :required="this.housetype == '住宅'">
        <el-input
          v-model="community"
          placeholder="格式示例：阳光花园"
        ></el-input>
      </el-form-item>
      <el-form-item label="申请人联系邮箱：">
        <el-input
          v-model="email"
          placeholder="格式示例：88888888@qq.com"
          type="email"
        ></el-input>
      </el-form-item>
      <el-form-item label="居室数：">
        <el-input
          v-model="bedrooms"
          placeholder="格式示例：3"
          type="number"
          min="0"
        ></el-input>
      </el-form-item>
      <el-form-item label="厅室数：">
        <el-input
          v-model="livings"
          placeholder="格式示例：1"
          type="number"
          min="0"
        ></el-input>
      </el-form-item>
      <el-form-item label="卫生间数：">
        <el-input
          v-model="bathrooms"
          placeholder="格式示例：1"
          type="number"
          min="0"
        ></el-input>
      </el-form-item>
      <el-form-item label="建筑年代：">
        <el-input v-model="buildAge" placeholder="格式示例：2001" type="text"></el-input>
      </el-form-item>
      <el-form-item label="楼层：">
        <el-input
          v-model="level"
          placeholder="格式示例：6"
          type="number"
          min="1"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input
          v-model="others"
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠代码：">
        <el-input
          v-model="discountCode"
        ></el-input>
      </el-form-item>
      <el-form-item style="text-align: center">
        <el-button type="primary" id="formSubmit" @click="handleSubmit"> 申请价值分析报告 </el-button>
      </el-form-item>
      <el-form-item style="text-align: center">
        <el-checkbox v-model="confirm" label="" size="large">点击"申请价值分析报告"按钮，即表示您已知晓并同意本报告为虚拟产品，不支持退款。</el-checkbox>
      </el-form-item>
    </el-form>
  </div>
  <purchase-dialog @closeDialog="closePurchaseDialog" v-if="purchaseDialogFlag" :dialogFlag="true" :content="purchaseContent"></purchase-dialog>
  <order-dialog @closeDialog="closeOrderDialog" v-if="orderDialogFlag" :dialogFlag="true" :content="orderDialogContent"></order-dialog>
  <br />
  <intro-table-b></intro-table-b>
</template>

<script>
import {
  ElForm,
  ElFormItem,
  ElInput,
  ElSelect,
  ElOption,
  ElButton,
  ElMessage,
  ElLoading,
  ElCheckbox,
  ElMessageBox
} from "element-plus";
import PurchaseDialog from '../PurchaseDialog.vue'
import OrderDialog from '../OrderDialog.vue'
import IntroTableB from './IntroTableB.vue'

export default {
  name: "EstateTable",
  data() {
    return {
      housetype: "住宅",
      city: "",
      address: "",
      area: "",
      phone: "",
      email: "",
      community: "",
      bedrooms: "",
      livings: "",
      bathrooms: "",
      buildAge: "",
      level: "",
      others: "",
      wxStartPay: 0,
      discountCode: "",
      confirm: true,
      openid: undefined,
      plat: this.checkPlatform(),
      appId: "wxe551f3723eb2fc05",
      housetypes: ["住宅", "商业", "工业", "办公", "写字楼租赁", "不限"],
      purchaseDialogFlag: false,
      orderDialogFlag: false,
      purchaseContent: undefined,
      wxPayParams: {},
      orderDialogContent: {
        msg: '未知错误,请联系客服',
        orders: []
      }
    };
  },
  components: { ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElButton, PurchaseDialog, OrderDialog, ElCheckbox, IntroTableB },
  methods: {
    closePurchaseDialog() {
      this.purchaseDialogFlag = false
    },
    showtime() {
      let nowdate = new Date();
      let year = nowdate.getFullYear(),
      month = nowdate.getMonth() + 1,
      date = nowdate.getDate(),
      h = nowdate.getHours(),
      m = nowdate.getMinutes(),
      s = nowdate.getSeconds()
      if (month <= 9) {
        month = "0" + month;
      }
      return '' + year + month + date + h + m + s;
    },
    closeOrderDialog() {
      this.orderDialogFlag = false
    },
    showPurchaseDialog(content) {
      this.purchaseContent = content
      this.purchaseDialogFlag = true
    },
    showOrderDialog() {
      this.orderDialogContent = {
        msg: '报告生成失败，请联系客服',
        orders: [{
          trade_no: this.order.trade_no,
          address: this.address,
          city: this.city,
          housetype: this.housetype,
          area: this.area,
          email: this.email,
          phone: this.phone
        }]
      }
      this.orderDialogFlag = true
    },
    showLoading(trade_no) {
      const options = {
        text: `您的订单号是：${trade_no}，报告正在生成，请注意生成报告时间大约5分钟，生成报告期间请勿关闭程序和网页，生成完会自动开始下载，如有问题请联系客服`,
        fullscreen: true
      }
      if (this.plat == 'wechat') {
        options.text = `您的订单号是：${trade_no}，正在生成报告，生成完成后会在微信内申请打开手机浏览器，请在弹窗后打开浏览器并点击下载，等待下载完成后于浏览器下载记录中即可查看报告。`
      }
      this.loadingInstance = ElLoading.service(options)
    },
    closeLoading() {
      this.loadingInstance.close()
    },
    goDownload(targetUrl) {
      this.loadingInstance.close()
      var title = this.city + '_' + this.address +  '_' + this.housetype + '_' + this.area + '_' + this.showtime() + '.docx'
      const ele = document.createElement('a')
      ele.setAttribute('href', targetUrl)
      ele.setAttribute('download', title)
      ele.click()
      // window.location.href=targetUrl
    },
    queryReport(trade_no) {
      const params = {
        trade_no: trade_no,
        housetype: this.housetype,
        city: this.city,
        address: this.address,
        area: this.area,
        phone: this.phone,
        email: this.email,
        bedrooms: this.bedrooms,
        livings: this.livings,
        bathrooms: this.bathrooms,
        buildAge: this.buildAge,
        level: this.level,
        discountCode: this.discountCode
      }
      console.log(params);
      this.$http.post(this.$api.Report.GeneReport, params, false).then(
        (response) => {
          console.log(response)
          if (response.status == 200) {
            let data = response.data
            if (data.status) {
              ElMessage({message: '报告生成成功,即将开始下载', type: 'success', duration: 5000})
              this.closeLoading()
              this.goDownload(data.download)
            } else {
              this.closeLoading()
              ElMessage({message: '报告生成失败，请联系客服', type: 'error', duration: 10000})
              this.showOrderDialog()
            }
          } else {
            this.closeLoading()
            ElMessage({message: '报告生成失败，请联系客服', type: 'error', duration: 10000})
            this.showOrderDialog()
          }
        },
        (error) => {
          console.log(error)
        }
      )
    },
    queryOrder(trade_no) {
      const params = {
        trade_no: trade_no
      }
      console.log(params);
      this.$http.post(this.$api.Report.CheckPayed, params, false).then(
        (response) => {
          console.log(response)
          if (response.status == 200) {
            let data = response.data
            if (data.status) {
              ElMessage({message: '付款成功！！', type: 'success', duration: 10000})
              this.closePurchaseDialog()
              this.showLoading(this.order.trade_no)
              this.queryReport(this.order.trade_no)
            } else {
              ElMessage({message: '报告生成失败，请联系客服', type: 'error', duration: 10000})
              this.showOrderDialog()
            }
          } else {
            this.closeLoading()
            ElMessage({message: '报告生成失败，请联系客服', type: 'error', duration: 10000})
            this.showOrderDialog()
          }
        },
        (error) => {
          console.log(error)
          this.closeLoading()
          ElMessage({message: '报告生成失败，请联系客服', type: 'error', duration: 10000})
          this.showOrderDialog()
        }
      )
    },
    handleSubmit() {
      if (!this.city) {ElMessageBox({message: '标准城市名为空', type: 'error'});return '';}
      if (!this.address) {ElMessageBox({message: '详细地址为空', type: 'error'});return '';}
      if (!this.area) {ElMessageBox({message: '房屋面积为空', type: 'error'});return '';}
      if (!this.phone) {ElMessageBox({message: '申请人手机号为空', type: 'error'});return '';}
      if (!this.confirm) {ElMessageBox({message: '请先勾选同意相关协议', type: 'error'});return '';}
      if (!/(13\d|14[579]|15[^4\D]|17[^49\D]|18\d)\d{8}/i.test(this.phone)) {ElMessageBox({message: '申请人手机号格式错误', type: 'error'});return '';}
      if (this.email != '' && !/\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/i.test(this.email)) {ElMessageBox({message: '申请人邮箱格式错误', type: 'error'});return '';}
      const params = {
        type: "1",
        housetype: this.housetype,
        city: this.city,
        address: this.address,
        area: this.area,
        phone: this.phone,
        plat: this.plat,
        email: this.email,
        community: this.community,
        bedrooms: this.bedrooms,
        livings: this.livings,
        bathrooms: this.bathrooms,
        buildAge: this.buildAge,
        level: this.level,
        others: this.others,
        discountCode: this.discountCode
      }
      console.log(params);
      if (this.plat == 'wechat' && !this.wxStartPay) {
        let pageUrl = this.parseQuery(window.location.href, 1)['baseurl'] + "?"
        if (this.housetype) {
          pageUrl += 'housetype=' + this.housetype + '&'
        }
        if (this.city) {
          pageUrl += 'city=' + this.city + '&'
        }
        if (this.address) {
          pageUrl += 'address=' + this.address + '&'
        }
        if (this.area) {
          pageUrl += 'area=' + this.area + '&'
        }
        if (this.phone) {
          pageUrl += 'phone=' + this.phone + '&'
        }
        if (this.email) {
          pageUrl += 'email=' + this.email + '&'
        }
        if (this.community) {
          pageUrl += 'community=' + this.community + '&'
        }
        if (this.bedrooms) {
          pageUrl += 'bedrooms=' + this.bedrooms + '&'
        }
        if (this.livings) {
          pageUrl += 'livings=' + this.livings + '&'
        }
        if (this.bathrooms) {
          pageUrl += 'bathrooms=' + this.bathrooms + '&'
        }
        if (this.buildAge) {
          pageUrl += 'buildAge=' + this.buildAge + '&'
        }
        if (this.level) {
          pageUrl += 'level=' + this.level + '&'
        }
        if (this.others) {
          pageUrl += 'others=' + this.others + '&'
        }
        pageUrl += 'wxStartPay=1'
        pageUrl = encodeURIComponent(encodeURI(pageUrl))
        let targetUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.appId + "&redirect_uri=" + pageUrl + "&response_type=code&scope=snsapi_base"
        if (this.discountCode) {
          targetUrl += '&state=' + this.discountCode
        }
        targetUrl += '#wechat_redirect'
        window.location.href = targetUrl
      }
      else {
        if (this.plat == 'wechat' && this.wxStartPay && this.openid) {params.code = this.openid}
        console.log(1);
        this.$http.post(this.$api.Report.Apply, params, false).then(
          (response) => {
            if (response.status == 200) {
              console.log(response)
              if (response.data.code == 200) {
                let data = response.data
                if (data.status) {
                  let wxMsg = JSON.parse(data.msg)
                  console.log(wxMsg);
                  if ('code_url' in wxMsg) {
                    // PC扫码支付
                    this.order = {
                      trade_no: data.trade_no,
                      code: wxMsg.code_url
                    }
                    this.showPurchaseDialog(this.order.code)
                    this.queryOrder(this.order.trade_no)
                  }
                  else if ('h5_url' in wxMsg) {
                    // H5浏览器调起支付
                    this.order = {
                      trade_no: data.trade_no,
                      code: wxMsg.h5_url
                    }
                    this.queryOrder(this.order.trade_no)
                    window.location.href = this.order.code
                  }
                  else if ('wx_browser' in wxMsg) {
                    // 微信内置浏览器调起微信支付
                    this.order = {
                      trade_no: data.trade_no,
                      code: undefined
                    }
                    this.wxPayParams = data
                    this.queryOrder(this.order.trade_no)
                    this.handleWxPay()
                  }
                  else {
                    ElMessage({message: '报告生成失败，请尝试重新申请或联系客服', type: 'error', duration: 10000})
                    this.showOrderDialog()
                  }
                }
              } else {
                if (this.wxStartPay) {this.wxStartPay=0}
                ElMessage({message: '报告生成失败，请尝试重新申请或联系客服', type: 'error', duration: 10000})
                this.showOrderDialog()
              }
            }
          },
          (error) => {
            console.log(error)
            if (this.wxStartPay) {this.wxStartPay=0}
            ElMessage({message: '报告生成失败，请尝试重新申请或联系客服', type: 'error', duration: 10000})
            this.showOrderDialog()
          }
        )
      }
    },
    handleWxPay() {
      let that = this;
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
              "WeixinJSBridgeReady",
              that.onWxBridgeReady,
              false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", that.onWxBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady",that. onWxBridgeReady);
        }
      } else {
        this.onWxBridgeReady();
      }
    },
    onWxBridgeReady() {
      if (this.wxPayParams.paySign) {
        WeixinJSBridge.invoke('getBrandWCPayRequest', {
          "appId": this.wxPayParams.appId,
          "timeStamp": this.wxPayParams.timeStamp,
          "nonceStr": this.wxPayParams.nonceStr,
          "package": this.wxPayParams.package,
          "signType": this.wxPayParams.signType,
          "paySign": this.wxPayParams.paySign
        }, function(res) {console.log('wx js bridge succeed!'),console.log(res);})
      } else {
        ElMessage({message: '报告生成失败，请尝试重新申请或联系客服', type: 'error', duration: 10000})
        this.showOrderDialog()
      }
    }
  },
  mounted: function() {
    let params = this.parseQuery();
    console.log(params);
    // 根据url解析折扣码
    if (this.plat == 'wechat') {
      if ('code' in params && 'state' in params) {
        this.openid = params.code;
        this.discountCode = params.state;
      } else if ('code' in params) {
        if (String.length(params.code) <= 24) {this.discountCode = params.code;}
        else {this.openid = params.code;}
      }
    } else {
      if ('code' in params) {
        this.discountCode = params.code;
      }
    }
    // 根据url解析已填写的参数
    if ('housetype' in params) {this.housetype = params.housetype}
    if ('city' in params) {this.city = params.city}
    if ('address' in params) {this.address = params.address}
    if ('area' in params) {this.area = params.area}
    if ('phone' in params) {this.phone = params.phone}
    if ('email' in params) {this.email = params.email}
    if ('community' in params) {this.community = params.community}
    if ('bedrooms' in params) {this.bedrooms = params.bedrooms}
    if ('livings' in params) {this.livings = params.livings}
    if ('bathrooms' in params) {this.bathrooms = params.bathrooms}
    if ('buildAge' in params) {this.buildAge = params.buildAge}
    if ('level' in params) {this.level = params.level}
    if ('others' in params) {this.others = params.others}
    // 根据plat及wxStartPay判断是否自动执行发起订单
    if (params.wxStartPay) {
      this.wxStartPay = params.wxStartPay
      this.handleSubmit()
    }

  }
};
</script>
<style lang="less">
.form-title {
  padding-left: 15px;
}
.table-container {
  width: 95%;
  margin: auto;
  padding: 25px 35px 25px 20px;
  border: solid 1px #2665a0;
  border-radius: 25px;
}
</style>


